import { Flex } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { Provider } from 'react-redux';

import { ChameleonProvider } from '../../libs/third-party/Chameleon';
import { ZendeskProvider } from '../../libs/third-party/Zendesk/zendeskProvider';
import { Collaboration } from '../Collaboration/Collaboration';
import { E2ClientProvider } from '../E2ClientProvider';
import { InfographLoader } from '../InfographLoader';
import { CheckerSettingsProvider } from './components/AccessibilityManager/AccessibilityChecker/checker.provider';
import { AccessibilityMenu } from './components/AccessibilityManager/AccessibilityManager';
import { BoundingBoxProvider } from './components/BoundingBox/useBoundingBox';
import { Clipboard } from './components/Clipboard';
import { ContextMenuProvider } from './components/ContextMenu/ContextMenuProvider';
import { EditBackgroundMenu } from './components/EditBackgroundMenu';
import { FlowModeProvider } from './components/FlowCore/FlowModeProvider';
import { Focus, FocusProvider } from './components/Focus';
import { FontProvider } from './components/FontProvider';
import { Head } from './components/Head';
import { KeyboardShortcut } from './components/KeyboardShortcut';
import { MainContainer } from './components/MainContainer';
import { CopyPasteShortcutModal } from './components/Modals/CopyPasteShortcutModal';
import { Navbar } from './components/Navbar';
import { PageArea } from './components/PageArea';
import { PageControls } from './components/PageControls/PageControls';
import { SideMenuSettings } from './components/SideMenuSettings/SideMenuSettings';
import { SkipLinks } from './components/SkipLinks';
import { WidgetMenu } from './components/WidgetMenu';
import { store } from './store';
import { HistoryManagerProvider } from './store/history/historyManager';
import { PersistManagerProvider } from './store/persistManager';

const Editor = (): ReactElement => {
  return (
    <ZendeskProvider>
      <ChameleonProvider>
        <Provider store={store}>
          <Head />
          <SkipLinks />
          <BoundingBoxProvider>
            <E2ClientProvider>
              <HistoryManagerProvider>
                <FocusProvider>
                  <CheckerSettingsProvider>
                    <PersistManagerProvider>
                      <Collaboration>
                        <Navbar />
                      </Collaboration>
                    </PersistManagerProvider>
                    <AccessibilityMenu />
                  </CheckerSettingsProvider>
                  <InfographLoader>
                    <ContextMenuProvider>
                      <FontProvider>
                        <MainContainer>
                          <WidgetMenu />
                          <FlowModeProvider>
                            <Flex direction={'column'} position={'relative'}>
                              <PageControls />
                              <PageArea />
                            </Flex>
                          </FlowModeProvider>
                          <SideMenuSettings />
                          <EditBackgroundMenu />
                        </MainContainer>
                      </FontProvider>
                      <KeyboardShortcut />
                      <Clipboard />
                    </ContextMenuProvider>
                    <CopyPasteShortcutModal />
                    <Focus />
                  </InfographLoader>
                </FocusProvider>
              </HistoryManagerProvider>
            </E2ClientProvider>
          </BoundingBoxProvider>
        </Provider>
      </ChameleonProvider>
    </ZendeskProvider>
  );
};

export default Editor;
